/**
 * Copyright 2016-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import ReducerIndex from 'qwc2/reducers/index';
import detailsReducer from '../reducers/details';
import DirtyUtils from '../utils/DirtyUtils';

ReducerIndex.register("details", detailsReducer);

export const ADD_DETAILWINDOW = 'ADD_DETAILWINDOW';
export const REMOVE_DETAILWINDOW = 'REMOVE_DETAILWINDOW';
export const SET_DETAILWINDOW = 'SET_DETAILWINDOW';
export const STEP_DETAILWINDOW = 'STEP_DETAILWINDOW';
export const SET_DETAILWINDOW_TAB = 'SET_DETAILWINDOW_TAB';

export function addDetailWindow(feature) {
    return {
        type: ADD_DETAILWINDOW,
        feature
    };
}

export function removeDetailWindow(window) {
    return {
        type: REMOVE_DETAILWINDOW,
        window
    };
}

/**
 * Shows another feature in the window.
 * By default this is a navigation step which is added to the history of the window.
 * With `replace`, the current entry is only refreshed (e.g. after saving).
 */
export function setDetailWindow(windowId, feature, {replace = false} = {}) {
    return (dispatch, getState) => {
        if (!replace) {
            const current = (getState().details.detailwindows || []).find(dw => dw.id === windowId);
            if (current && JSON.stringify(current.feature) === JSON.stringify(feature)) {
                return;
            }
            if (!DirtyUtils.confirmLeave(getState(), windowId)) {
                return;
            }
        }
        dispatch({
            type: SET_DETAILWINDOW,
            windowId,
            feature,
            replace
        });
    };
}

// Moves through the history of the window, delta -1 goes back, 1 goes forward
export function stepDetailWindow(windowId, delta) {
    return (dispatch, getState) => {
        const current = (getState().details.detailwindows || []).find(dw => dw.id === windowId);
        const target = current && (delta < 0 ? current.past : current.future);
        if (!target || target.length === 0) {
            return;
        }
        if (!DirtyUtils.confirmLeave(getState(), windowId)) {
            return;
        }
        dispatch({
            type: STEP_DETAILWINDOW,
            windowId,
            delta
        });
    };
}

// Remembers the active tab of the current view, so that it can be restored via the history
export function setDetailWindowTab(windowId, tab) {
    return {
        type: SET_DETAILWINDOW_TAB,
        windowId,
        tab
    };
}
